import './Contact.css';

const Contact = () => {
  return (
    <div className="contact-page">
      <div className="container">
        <h1>Contact Us</h1>
        
        <div className="contact-content">
          <div className="contact-info">
            <h2>Get in Touch</h2>
            <div className="info-item">
              <h3>Address</h3>
              <p>
                209 Wilkinson Road<br />
                Brampton, Ontario L6T 4M2<br />
                Canada
              </p>
            </div>
            
            <div className="info-item">
              <h3>Phone</h3>
              <p>
                <a href="tel:+19057965885">905.796.5885</a>
              </p>
            </div>
            
            <div className="info-item">
              <h3>Fax</h3>
              <p>905.796.5471</p>
            </div>
            
            <div className="info-item">
              <h3>Email</h3>
              <p>
                <a href="mailto:sales@rollformmachine.com">sales@rollformmachine.com</a>
              </p>
            </div>
            
            <div className="info-item">
              <h3>Business Hours</h3>
              <p>
                Monday - Friday: 8:00 AM - 5:00 PM EST<br />
                Saturday - Sunday: Closed
              </p>
            </div>
          </div>
          
          <div className="contact-map">
            <h2>Location</h2>
            <div className="map-container">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2882.842983796494!2d-79.7094!3d43.7315!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x882b3c5c3a1b1b1b%3A0x1b1b1b1b1b1b1b1b!2s209%20Wilkinson%20Rd%2C%20Brampton%2C%20ON%20L6T%204M2%2C%20Canada!5e0!3m2!1sen!2sus!4v1640000000000!5m2!1sen!2sus"
                width="100%"
                height="300"
                style={{ border: 0, borderRadius: 'var(--radius-md)' }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Roll Forming Machine & Die Manufacturing Location"
              ></iframe>
              <div className="directions">
                <h3>Directions</h3>
                <p>
                  <strong>From Toronto:</strong> Take Highway 401 West to Highway 410 North. 
                  Exit at Steeles Avenue and turn left. Turn right on Wilkinson Road.
                </p>
                <p>
                  <strong>From Mississauga:</strong> Take Highway 410 North to Steeles Avenue. 
                  Turn left on Steeles, then right on Wilkinson Road.
                </p>
              </div>
            </div>
          </div>
        </div>
        
        <div className="contact-cta">
          <h2>Ready to Get Started?</h2>
          <p>
            Contact us today to discuss your roll forming needs. Our experienced team 
            is ready to help you find the perfect solution for your project.
          </p>
          <a href="/quote" className="cta-button">Request a Quote</a>
        </div>
      </div>
    </div>
  );
};

export default Contact;
